import { PayloadAction } from "@reduxjs/toolkit";
import axios, { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import { Locations } from "../../../../services/reddyApi/Locations/Locations";
import { GetLocationResponse } from "../../../../services/reddyApi/Locations/Locations.response";
import handleServerError from "../../all/saga/handleServerError";
import setServerErrorDefault from "../../all/saga/setServerErrorDefault";
import { getLocationFetch, getLocationSuccess } from "../locations.slice";
import { GetLocationPayload } from "../payload/GetLocation/GetLocationPayload";

function* getLocationWorker(action: PayloadAction<GetLocationPayload>) {
    const { vendorId, locationId } = action.payload;

    try {
        const { status, data }: AxiosResponse<GetLocationResponse> = yield call(Locations.getLocation, { vendorId, locationId });

        if (status === 200) {
            yield put(getLocationSuccess({ location: { ...data } }));

            yield setServerErrorDefault();
        }
    } catch (error) {
        if (axios.isAxiosError(error)) {
            const actionCreator = () => getLocationFetch(action.payload);

            yield handleServerError(error, actionCreator);
        }
    }
}

export default getLocationWorker;